export const renderActiveResolvedColor = (status) => {
    switch (status) {
        case true:
            return 'green';
        case false:
            return 'blue';
        default:
            return 'blue';
    }
}